import { useEffect, useState } from 'react'
import { api, type User } from '../api'
import { Button, Callout } from './ui'

export function Login({ onSignedIn }: { onSignedIn: (u: User, synthetic: boolean) => void }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const [mode, setMode] = useState<string | null>(null)
  useEffect(() => {
    fetch('/api/v1/health')
      .then((r) => r.json())
      .then((h) => setMode(h.mode), () => setMode(null))
  }, [])

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      const { user, synthetic } = await api.login(username.trim(), password)
      onSignedIn(user, synthetic)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed')
      setPassword('')
    } finally {
      setBusy(false)
    }
  }

  const input = 'h-11 w-full rounded-lg border border-border bg-surface px-3 text-base'
  return (
    <main className="flex min-h-full items-center justify-center p-4">
      <div className="w-full max-w-sm rounded-2xl border border-border bg-surface p-6 shadow-panel">
        <div className="mb-6 text-center">
          <img src="/ewsfiber-logo.png" alt="EWS Fiber" className="mx-auto h-24 w-auto" width={150} height={96} />
          <h1 className="mt-3 text-lg font-semibold leading-tight">Network Management System</h1>
          <p className="text-sm text-muted">Fibre plant, faults and field work</p>
        </div>
        <form onSubmit={submit} className="space-y-4" noValidate>
          {error && <Callout tone="danger" title={error} />}
          <div>
            <label htmlFor="username" className="mb-1 block text-sm font-medium">
              Username
            </label>
            <input id="username" className={input} autoComplete="username" autoCapitalize="none" value={username} onChange={(e) => setUsername(e.target.value)} required autoFocus />
          </div>
          <div>
            <label htmlFor="password" className="mb-1 block text-sm font-medium">
              Password
            </label>
            <input id="password" type="password" className={input} autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </div>
          <Button type="submit" variant="primary" className="h-11 w-full" busy={busy} disabled={!username || !password}>
            Sign in
          </Button>
        </form>
        {mode === 'dev' ? (
          <p className="mt-5 text-xs text-muted">Development build with synthetic data. Demo accounts: demo-viewer, demo-noc, demo-engineer, demo-admin (password printed by the API at start-up).</p>
        ) : (
          <p className="mt-5 text-center text-xs text-muted">No login yet? Ask IT to create one for you.</p>
        )}
      </div>
    </main>
  )
}
